module.exports = __webpack_public_path__ + "static/media/weather.7c947403.svg";